<style lang="less">
    .page_con.poly{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background:url("../assets/images/topbar-4.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.6rem;
                height:auto;
                display: block;
            }
            p{
                font-size: .4rem;
                color:#fff;
                font-weight: bold;
                margin-left:.1rem;
                letter-spacing: .05rem;
            }
        }
        .content_con{
            width:100%;
            height:79vh;
            .part1{
                .text_con{
                    width:100%;
                    margin:20vh 0 0;
                    padding:5vh 10vw;
                    height:40vh;
                    font-size: .5rem;
                    background:#FCD587;
                }
                .start_btn{
                    img{
                        width:30vw;
                        height:auto;
                        display: block;
                        margin:10vh auto 0;
                    }
                }
            }
            .part2{
                .questtion_con{
                    width:100%;
                    height:30vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .5rem;
                    letter-spacing: .05rem;
                    padding:0 10vw;
                    background: #FCD587;
                }
                .answer_con{
                    width:100%;
                    padding:2vh 5vw;
                    >p{
                        width:100%;
                        padding:0 10vw;
                        font-size: .4rem;
                    }
                    .answers{
                        width:100%;
                        padding:5vh 5vw;
                        .answer_item{
                            width:100%;
                            height:10vh;
                            background:#009237;
                            border-radius: 20px;
                            margin-bottom: 1vh;
                            padding:1vh 4vw;
                            color:#fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            box-shadow: 0px -10px 7px 0px inset rgba(0,0,0,.15);
                            .circle{
                                width:7vw;
                                height:7vw;
                                background:#fff;
                                border-radius: 50%;
                                margin-right:2vw;
                                border:.05rem solid #fff;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                            .circle.active{
                                background:#000;
                            }
                            .item_text{
                                flex:1;
                                font-size: .3rem;
                                letter-spacing: .03rem;
                            }
                        }
                    }
                }
            }
        }
        .btns{
            width:100%;
            height:10vh;
            // position: fixed;
            bottom: 0;
            left: 0;
            z-index: 11;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width:25vw;
                height:auto;
                display: block;
            }
        }
    }
</style>
<template>
    <div class="page_con poly">
        <div class="top_con">
            <img src="../assets/images/time.png" alt="">
            <interval :time="time" ref="time"></interval>
        </div>
        <!-- <div class="quest_num">
            <img src="../assets/images/grade-button.png" alt="">
            <p>第112題</p>
        </div> -->
        <div class="content_con">
            <div class="part1" v-if="part === 1">
                <div class="text_con">
                    <!-- <p>根據上文下理，判別<span class="red">紅色</span>詞語屬於《活學小詞典》中哪一種解釋：</p> -->
                    <p v-html="data.title"></p>
                </div>
                <div class="start_btn">
                    <img src="../assets/images/start-button.png" @click="part=2" alt="">
                </div>
            </div>
            <div class="part2" v-if="part === 2">
                <div class="questtion_con">
                    <p v-html="data.game[current].topics"></p>
                </div>
                <div class="answer_con">
                    <p>請選擇適當「<span class="red">{{data.game[current].word}}</span>」的解釋。</p>
                    <div class="answers">
                        <template v-for="(item,index) in data.game[current].options">
                            <div class="answer_item" v-if="item !='0'" @click="choose(item,index)" :key="index">
                                <div :class="['circle',index===choiced?'active':'']"></div>
                                <p class="item_text">{{item.text}}</p>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns" v-if="part === 2">
            <img src="../assets/images/back-button.png" @click="$router.go(-1)" alt="">
            <img src="../assets/images/submit.png" @click="submit" alt="">
        </div>
        
        <div class="shade" v-if="tips_bag || toast != 'none'">
            <div class="tips_bag" v-if="tips_bag">
                <img src="../assets/images/tip-bg.png" alt="">
                <img class="close" src="../assets/images/close-tipbutton.png" alt="" @click="tips_bag='close'">
                
                <p v-if="data.tips" v-html="data.tips"></p>
                <p v-else style="text-align:center;" v-html="'今天沒有學習錦囊'"></p>
            </div>


            <div class="toast" v-if="toast != 'none'">
                <div v-if="toast == 'success'" class="toast_success">
                    <template v-if="isEnd">
                        <img class="result" src="../assets/images/DONE-answer.png" alt="">
                        <img src="../assets/images/backhome.png" alt="" class="goon" @click="answerEnd">
                    </template>
                    <template v-else>
                        <img class="result" src="../assets/images/yes-answer.png" alt="">
                        <img src="../assets/images/next.png" alt="" class="goon" @click="next">
                    </template>
                </div>
                <div v-if="toast == 'error'" class="toast_error">
                    <img class="result" src="../assets/images/NO-answer.png" alt="">
                    <img src="../assets/images/continue.png" alt="" class="goon" @click="reset">
                </div>
            </div>
        </div>
        <div class="shade tips_result" v-if="tips_bag == 'close'">
            <div class="tips_result">
                <img class="readed" src="../assets/images/read-done.png" alt="">
                <img class="close" @click="tips_bag=false" src="../assets/images/certain-button.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import interval from './timer';
export default {
    components:{
        interval
    },
    data(){
        return {
            pauseStatus:false,  //暫停狀態
            time:300,    //倒計時
            
            setsIndex:0,        //当前第几套题
            isEnd:false,        //是否结束
            
            tips_bag:'',
            toast:'none',
            tips_time:0,        //锦囊使用次数
            
            data:{
                tips:'',
                game:[],
                title:'',
            },
            part:1,
            choiced:'',
            current:0,      //第几题
            // answers:[],

            right_temp:0,       //小題是否正確
            is_right:1,         //是否全對
        }
    },
    mounted() {
        let query = this.$route.query;
        this.getData(query.date);
    },
    methods: {
        choose(item,index){
            this.right_temp = item.right;
            this.choiced = index;
        },
        answerEnd(){
            this.updateData(this.getTime(),this.tips_time,this.is_right,this.$route.query.date);
        },
        submit(){
            if(this.right_temp){
                if(this.current<this.data.game.length-1){   //是否是最后一题
                    // this.current+=1;
                    // this.reset();
                    this.toast = 'success';
                }else{  //题目打完 提交数据
                    let setsIndex = this.setsIndex;
                    // if(this.$store.getters.gameData[setsIndex]){    //是否還有套題
                    //     // this.setsIndex = setsIndex;
                    //     // this.reset();
                    //     // this.init(setsIndex);
                    // }else{
                    //     this.isEnd = true;
                    // }
                    if(!this.hasMore()){
                        this.isEnd = true;
                    }
                    this.toast = 'success';
                }
            }else{
                this.toast = 'error';
            }
        },
        getTime(){
            return this.time - this.$refs.time.getTime();
        },
        reset(){
            this.toast = 'none';
            this.tips_bag = '';
            this.choiced = '';
            this.right_temp = 0;
        },
        openTip(){
            this.tips_bag = true;
            this.tips_time++;
        },
        next(){
            if(this.current<this.data.game.length-1){   //是否是最后一题
                this.current+=1;
                this.reset();
            }else{  //题目打完 提交数据
                if(this.hasMore()){
                    this.setsIndex += 1;
                    this.current = 0;
                    this.reset();
                    this.init(this.setsIndex);
                }else{
                    this.isEnd = true;
                    this.toast = 'success';
                }
            }
        },
        hasMore(){
            let setsIndex = this.setsIndex + 1;
            if(this.$store.getters.gameData[setsIndex]){
                return true;
            }else{
                return false;
            }
        },
        saveData(){
            this.$router.push('/index');
        },
        getData(date){
            let vm = this;
            vm.$http.get('/GameDaily/index?type=10&rest_key=1'+(date?('&pushdate='+date):'')).then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setGameData',res.data.data.game);
                    vm.init(vm.setsIndex);
                }
            })
        },
        init(sets){
            let data = JSON.parse(JSON.stringify(this.$store.getters.gameData[sets]));
            data.title = data.title.replace(data.word,'<span class="red">'+data.word+'</span>');
            data.game = data.game.map(v=>{
                if(v.topics && v.topics != null && v.topics!='0'){
                    v.topics = v.topics.replace(v.word,'<span class="red">'+v.word+'</span>');
                    let arr = v.options;
                    let opts = [];
                    for(let i=0;i<arr.length;i++){
                        if(arr[i] == '0' || arr[i] == '' || arr[i] == null){
                            continue;
                        }else{
                            opts.push({
                                text:arr[i],
                                right:i==0?1:0
                            });
                        }
                    }
                    v.options = this.randomIndex(opts);
                    return v;
                }
            }).filter(v=>{return v});
            this.data = data;
            console.log(this.data);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/polysemy.vue